import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LmoOrdersReplacementComponent } from '~lmo/components/lmo-orders-replacement/lmo-orders-replacement.component';
import { LmoOrdersNewComponent } from '../lmo-orders-new/lmo-orders-new.component';

@Component({
  selector: 'sa-lmo-new-order-button',
  styleUrls: ['./lmo-new-order-button.component.scss'],
  templateUrl: './lmo-new-order-button.component.html',
})
export class LmoNewOrderButtonComponent implements OnInit {
  constructor(private matDialog: MatDialog) {}

  public ngOnInit() {}

  public openNewOrderModal() {
    this.matDialog.open(LmoOrdersNewComponent, {
      minWidth: '500px',
    });
  }

  public openReplacementOrderModal() {
    this.matDialog.open(LmoOrdersReplacementComponent, {
      minWidth: '500px',
    });
  }
}
